module.exports = __webpack_public_path__ + "al.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/al.svg
// module id = 414
// module chunks = 0